import { Api } from '@/src/store/api'

export const PointsForStatementCreditApi = Api.enhanceEndpoints({
  endpoints: {
    'POST /card/credit/:cardAccountId/redeem-points': {
      invalidatesTags: [
        'GET /card/accounts/:cardAccountId',
        'GET /card/activity-feed/:cardAccountId',
      ],
    },
  },
})
